import React from "react";
import styled from "styled-components";
import { theme } from "styles/mui-config";

const Backdrop = styled.div`
  height: 100vh;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2002;
`;

const ProgressBarWrapper = styled.div`
  width: 50%;
  height: 20px;
  border-radius: 10px;
  background-color: #ddd;
  margin-bottom: 10px;
`;

const ProgressBar = styled.div`
  height: 100%;
  border-radius: 10px;
  background-color: ${theme.palette.primary.main};
  width: ${(props) => `${Math.round(props.progress)}%`};
  transition: 300ms;
  float: left;
`;

const ProgressIndicator = styled.div`
  text-align: center;
  color: #fff;
  font-weight: bold;
`;

const UploadBackdrop = ({ value: progress }) => {
  return (
    <Backdrop>
      <ProgressBarWrapper>
        <ProgressBar progress={progress} />
      </ProgressBarWrapper>
      <ProgressIndicator>{Math.round(progress)}%</ProgressIndicator>
    </Backdrop>
  );
};

export default UploadBackdrop;
